import React, { FC } from 'react';
import styles from './info-box.module.sass';

export const InfoBoxHeader : FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({className, ...props}) => {
  return <span {...props} className={`${styles.header} ${className ?? ""}`}>{props.children}</span>
}
export default InfoBoxHeader;
